module.exports = __webpack_public_path__ + "static/media/react.e1eb5856.png";